module.exports = __webpack_public_path__ + "img/text.2711bb1f.png";